<div class="main-page cadastros">
    <div class="container-fluid">
        <app-title>Regra Relatorio</app-title>

        <div class="row mt-3 no-gutters p-4 row-form">
            <div class="col-12">
                <form [formGroup]="reportingRuleForm" (ngSubmit)="submitForm()">
                    <h2 class="mb-3">Dados da Regra Relatorio</h2>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <mat-form-field appearance="outline">
                                <mat-label>Tipo do Relatorio</mat-label>
                                <mat-select formControlName="typeReport" [(value)]="typeReportSelected" required>
                                    <mat-option *ngFor="let type of reportTypes" [value]="type.uuid"
                                        style="text-transform: uppercase;">
                                        {{ type.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="form-group col-md-8">
                            <mat-form-field appearance="outline">
                                <mat-label>Tipo de Parâmetros (Descrição / Operação)</mat-label>
                                <mat-select formControlName="typeParameters" [(value)]="typeParametersSelected"
                                    required>
                                    <mat-option *ngFor="let type of parametersValids" [value]="type.uuid"
                                        style="text-transform: uppercase;">
                                        {{ type.name }} / {{ getOperationTypeDescription(type.operation_type) }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-lg-3">
                            <mat-form-field appearance="outline">
                                <mat-label>Valor</mat-label>
                                <input formControlName="valueRule" required matInput type="text"
                                    placeholder="Valor da Regra" pattern="^-?\d*(\.\d+)?$" />
                            </mat-form-field>
                        </div>

                    </div>


                    <div *ngIf="errorMessage" class="alert alert-danger">
                        {{ errorMessage }}
                    </div>

                    <div class="form-group mt-2 mb-0 text-center">
                        <back-button></back-button>
                        <button type="submit" [disabled]="!reportingRuleForm.valid"
                            class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0">
                            Atualizar Regra para Relatorio
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>